// extracted by mini-css-extract-plugin
export default {"root":"RlQlAOWP","title":"uhFND0Rf","disabled":"i96wiImC"};